import React, { Component } from 'react';
import ReactToPrint from "react-to-print";
import firebase from './Fireb';
import moment from 'moment';
import logo from '../aplogo.png'

class Reciept extends Component {
    constructor(props) {
      super(props);
      this.state = {
        VendorPay: [],
        vendor: [],
          key: '',
          i:0,
      };
      
    }
  
  
  
    componentDidMount() {
        const ref = firebase.firestore().collection('vendorPay').doc(this.props.match.params.id);
        ref.get().then((doc) => {
          if (doc.exists) {
            this.setState({
              VendorPay: doc.data(),
              key: doc.id,
              isLoading: false
            });
          } else {
            console.log("No such document!");
          }
        });
        const ref1 = firebase.firestore().collection('vendor').doc(firebase.auth().currentUser.uid);
        ref1.get().then((doc) => {
          if (doc.exists) {
            this.setState({
              vendor: doc.data(),
              key1: doc.id,
              isLoading: false
            });
          } else {
            console.log("No such document!");
          }
        });
      
    }
    onClick() {
      const btnPrint = document.querySelector("#btnPrint");
      btnPrint.addEventListener("click", () => {
          window.print();
      });
      }
    render(){
      return(
        
        <div class="ticket">
        <img class="one" src={logo} alt="Logo"/>
        <p class="centered">PAYMENT RECEIPT</p>
    
                                <br/>Invoice #: {this.state.i+=1} <br></br>
                                Created: {moment(Date()).format("lll")}<br></br>
            <br></br> Gulshan-e-Iqbal,Karachi
                             
            <br/>Usman Institite of Technology<br></br>
            <br/>
        <table>
            <thead>
                <tr>
                    <th class="description">Vendor</th>
                    <th class="quantity">Q.</th>
                    <th class="description">PKR</th>
                    <th class="description">Date</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="quantity">{this.state.VendorPay.vname}</td>
                    <td class="quantity">{this.state.VendorPay.tno}</td>
                    <td class="description">{this.state.VendorPay.Bill}</td>
                    <td class="description">{this.state.VendorPay.day}</td>
                </tr>
            </tbody>
        </table>
        <br></br>
        <p class="centered">Thanks for using cashless!</p>
    
    <button id="btnPrint" class="hidden-print" style={{backgroundImage: "linear-gradient(to left, #000428 , #004e92)",
           color: "#d9b74c",
           fontSize: "14px",
           cursor: "pointer",
           padding: "10px",
           margin: "5px",
     transition: "all .5s ease-in-out"}}onClick={this.onClick.bind(this)}>Print Reciept</button>
    <script src="script.js"></script>
    </div>
    
      )
    }
  } 
    export default Reciept;
    